import { CoordinatorService } from './coordinator.service';
import { ScriptArchivedSearch } from './script-archived-search';

export class ScriptSearchArchive {
    #coords: CoordinatorService;

    constructor(coords: CoordinatorService) {
        this.#coords = coords;
    }

    list() {
        return this.#coords.searchArchive$
            .searchLs()
            .map((s) => new ScriptArchivedSearch(this.#coords, s));
    }

    get(tag: string) {
        for (let s of this.#coords.searchArchive$.searchLs()) {
            if (s.id === tag || s.title === tag) return new ScriptArchivedSearch(this.#coords, s);
        }
        return null;
    }
}
